import React from 'react';

const ConditionalContext = React.createContext(null);

export default ConditionalContext;
